import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/layout/Footer';
const PrivacyPolicy: React.FC = () => {
  return (
    <div className="bg-white">
      <Navbar />

      <div className="pt-24 pb-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
          <p className="mb-6">
            <strong>Effective Date:</strong> April 2025<br />
            <strong>Last Updated:</strong> April 2025
          </p>

          <div className="prose prose-lg max-w-none">
            <p className="mb-4">
              Atompass ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, store, and safeguard your personal information when you use our web application or Chrome Extension.
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">1. Information We Collect</h2>
              <ul className="list-disc pl-6 mb-4">
                <li><strong>Account Information</strong>: Email, name, phone number, and business details.</li>
                <li><strong>Stored Credentials and Notes</strong>: Passwords and notes stored securely using AES-256 encryption.</li>
                <li><strong>Usage Data</strong>: Device/browser info and usage analytics.</li>
                <li><strong>Payment Details</strong>: Processed via Stripe; we do not store card info.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">2. How We Use Your Information</h2>
              <ul className="list-disc pl-6 mb-4">
                <li>Provide secure password and note storage</li>
                <li>Enable autofill and password generation</li>
                <li>Support shared vault features</li>
                <li>Billing and support purposes</li>
                <li>Product improvement</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">3. Data Security</h2>
              <p>
                We use AES-256 encryption, PBKDF2 key derivation, SSL encryption, and multi-key architectures. Only users can decrypt their own stored data using their master password.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">4. Data Storage & Processing</h2>
              <p>
                Data is stored in secure cloud infrastructure and may be processed in various regions depending on infrastructure setup.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">5. Your Rights & Data Deletion</h2>
              <p>
                You may request full account and data deletion by emailing <a href="mailto:support@atompass.com" className="text-blue-600">support@atompass.com</a>. All deletions are permanent and processed within 7 business days.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">6. Third-Party Services</h2>
              <p>
                We use services like Google Analytics, Stripe, and email delivery systems. These services may collect anonymized metadata as per their respective privacy policies.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">7. Contact Us</h2>
              <p>
                Email: <a href="mailto:support@atompass.com" className="text-blue-600">support@atompass.com</a><br />
                Website: <a href="https://atompass.com" className="text-blue-600">https://atompass.com</a>
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />  
    </div>

  );
};

export default PrivacyPolicy; 